import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';

const createUserMutation = graphql(/* GraphQL */ `
  mutation createUser($user: UserInput!) {
    createUser(user: $user)
  }
`);

export type UserInput = {
  userId: number;
  auth0Id: string;
  fullName: string;
  email: string;
  gender: string;
  phone: string;
  specialRequest: string;
};

const useCreateUser = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const mutation = useMutation({
    mutationFn: async (user: UserInput) => {
      // User creation might happen during registration, but if authenticated, use token
      return graphqlRequest(
        createUserMutation,
        { user },
        isAuthenticated ? getAccessTokenSilently : undefined,
      );
    },
  });

  return mutation;
};

export default useCreateUser;
